import React from 'react'
import { Paragraph, useContainerWidth, Separator } from '@fs/zion-ui'
import { useRootsTechBannerViewContext, viewTypes } from './internal/RootsTechBannerViewProvider'

export default function RootsTechBannerText({ children, ...props }) {
  const atSize = useContainerWidth()
  const viewType = useRootsTechBannerViewContext()
  const isCollapsed = viewType === viewTypes.COLLAPSED
  const style = {}
  if (isCollapsed) {
    style.maxWidth = '585px'
    style.width = '100%'
  }

  return (
    <>
      {!isCollapsed && <Separator size={atSize({ default: 'xs', xxl: 'xs' })} />}
      <div style={style}>
        <Paragraph size={atSize({ default: 'xs', md: 'sm' })} balanced={!isCollapsed} {...props}>
          {children}
        </Paragraph>
      </div>
    </>
  )
}
